/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrossModuleActionContextRequest } from './CrossModuleActionContextRequest';
import {
    CrossModuleActionContextRequestFromJSON,
    CrossModuleActionContextRequestFromJSONTyped,
    CrossModuleActionContextRequestToJSON,
    CrossModuleActionContextRequestToJSONTyped,
} from './CrossModuleActionContextRequest';

/**
 * 
 * @export
 * @interface CrossModuleActionPreviewRequest
 */
export interface CrossModuleActionPreviewRequest {
    /**
     * 
     * @type {string}
     * @memberof CrossModuleActionPreviewRequest
     */
    actionId?: string;
    /**
     * 
     * @type {CrossModuleActionContextRequest}
     * @memberof CrossModuleActionPreviewRequest
     */
    context?: CrossModuleActionContextRequest;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CrossModuleActionPreviewRequest
     */
    parameters?: { [key: string]: any; };
}

/**
 * Check if a given object implements the CrossModuleActionPreviewRequest interface.
 */
export function instanceOfCrossModuleActionPreviewRequest(value: object): value is CrossModuleActionPreviewRequest {
    return true;
}

export function CrossModuleActionPreviewRequestFromJSON(json: any): CrossModuleActionPreviewRequest {
    return CrossModuleActionPreviewRequestFromJSONTyped(json, false);
}

export function CrossModuleActionPreviewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrossModuleActionPreviewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'actionId': json['actionId'] == null ? undefined : json['actionId'],
        'context': json['context'] == null ? undefined : CrossModuleActionContextRequestFromJSON(json['context']),
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
    };
}

export function CrossModuleActionPreviewRequestToJSON(json: any): CrossModuleActionPreviewRequest {
    return CrossModuleActionPreviewRequestToJSONTyped(json, false);
}

export function CrossModuleActionPreviewRequestToJSONTyped(value?: CrossModuleActionPreviewRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actionId': value['actionId'],
        'context': CrossModuleActionContextRequestToJSON(value['context']),
        'parameters': value['parameters'],
    };
}

